import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/media")({
  beforeLoad: () => {
    throw redirect({ to: "/insights/media", statusCode: 301 });
  },
});
